import { BACKFILL_ADMIN_A_VOCABULARIES } from './backfill-admin-a.js';
/** D577 slice for the Admin console (A-L screens and components): vocabularies the app translated locally and the catalog lacked. */
export const SLICE_ADMIN_A = [...BACKFILL_ADMIN_A_VOCABULARIES];
//# sourceMappingURL=slice-admin-a.js.map